import { Dictionary } from '@/dictionary/Dictionary'
import i18n from '@/i18n'

const deliveryPriceRoundingModes: Array<Dictionary> = []

for (const code of ['none', 'default', 'bigger', 'smaller']) {
    deliveryPriceRoundingModes.push({
        code: code,
        name: i18n.t(`dictionary.deliveryPriceRoundingMode.${code}`).toString()
    })
}

export { deliveryPriceRoundingModes }
